export const TAMANHOS_BOTAO = {
    pequeno: ['px-3', 'py-2', 'text-sm'],
    medio: ['px-4', 'py-3', 'text-base'],
    grande: ['px-6', 'py-4', 'text-lg'],
};

export const CORES_BOTAO = {
    primario: ['bg-blue-500', 'text-white', 'border-blue-500', 'hover:bg-blue-600', 'hover:border-blue-600'],
    secundario: ['bg-transparent', 'text-blue-500', 'border-blue-500', 'hover:bg-blue-500', 'hover:text-white'],
    sucesso: ['bg-green-500', 'text-white', 'border-green-500', 'hover:bg-green-600', 'hover:border-green-600'],
    perigo: ['bg-red-500', 'text-white', 'border-red-500', 'hover:bg-red-600', 'hover:border-red-600'],
    aviso: ['bg-yellow-500', 'text-white', 'border-yellow-500', 'hover:bg-yellow-600', 'hover:border-yellow-600'],
    info: ['bg-blue-400', 'text-white', 'border-blue-400', 'hover:bg-blue-500', 'hover:border-blue-500'],
};

export const CLASSES_DESABILITADO = ['opacity-60', 'cursor-not-allowed', 'pointer-events-none'];
export const CLASSE_LARGURA_COMPLETA = 'w-full';
export const CLASSE_ARREDONDADO = 'rounded-3xl';
export const CLASSE_PADRAO = 'rounded-md';
